import React, { Component } from 'react';
import AgentDetail from './AgentDetail';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as agentDetailActions from '~/store/modules/agentDetail';

export class AgentDetailContainer extends Component {
  componentDidMount() {
    const { AgentDetailActions, match, isLoggedIn } = this.props;
    const { agentId } = match.params;

    AgentDetailActions.getAgent(agentId);
    if (isLoggedIn) {
      AgentDetailActions.initReviewList(agentId);
    }
  }

  componentWillUnmount() {
    const { AgentDetailActions } = this.props;
    AgentDetailActions.clear();
  }

  getNextReviews = () => {
    const { AgentDetailActions, agentDetail } = this.props;
    const {
      id,
      originalReviewList,
      reviewList,
      isMoreReviews,
      reviewsCurrentPage,
    } = agentDetail;

    if (!isMoreReviews) {
      return;
    }

    if (originalReviewList.size > reviewList.size) {
      AgentDetailActions.setReviewList(originalReviewList);
    } else {
      AgentDetailActions.getNextReviewList({
        id,
        page: reviewsCurrentPage + 1,
      });
    }
  };

  render() {
    return <AgentDetail {...this.props} getNextReviews={this.getNextReviews} />;
  }
}

export default connect(
  ({ agentDetail, pender, session }) => ({
    agentDetail,
    isLoggedIn: session.isLoggedIn,
    loading: pender.pending['agentDetail/GET_AGENT'],
    loadingReviews: pender.pending['agentDetail/INIT_REVIEW_LIST'],
    error: pender.failure['agentDetail/GET_AGENT'],
  }),
  dispatch => ({
    AgentDetailActions: bindActionCreators(agentDetailActions, dispatch),
  })
)(AgentDetailContainer);



// WEBPACK FOOTER //
// ./src/components/AgentDetail/AgentDetailContainer.js